import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters("auth", ["isGuestUser", "isLoggedIn"]),
    getUrlName() {
      return this.isLoggedIn && this.isGuestUser ? "sharingZone" : "privateZone"
    },
  },
}
